<template>
  <div class="invisible-scrollbar">
    <v-card style="display: contents">
      <div class="manage-role-page">
        <div class="page-title">
          {{ $t("message.ManageRole") }}
        </div>
        <v-card-text class="manage-role-content">
          <div class="search-section">
            <div class="search-control">
                  <v-text-field
                    :placeholder="$t('message.Search')"
                    :aria-label="$t('message.Search')"
                    v-model="search"
                    v-on:keyup.enter="SearchDataRoleList(search)"
                    clearable
                    outlined
                    hide-details
                    class="search-field"
                  >
                    <template v-slot:append>
                      <img
                        :src="require('@/assets/icons/search-normal.png')"
                        alt=""
                        class="search-normal-icon"
                      />
                    </template>
                  </v-text-field>
            </div>
            <div class="create-control">
                  <v-btn
                    color="#231F20"
                    class="white--text create-role-btn"
                    @click="OpenAddRoleDetailDialog()"
                  >
                    {{ $t("message.Create") }}
                    <v-icon right>mdi-plus</v-icon>
                  </v-btn>
            </div>
          </div>

          <v-card elevation="0" class="table-card">
            <div class="table-scroll">
              <v-data-table
                :headers="
                  $vuetify.breakpoint.smAndDown ? headersMobile : headers
                "
                :items="ListData"
                hide-default-footer
                class="data-table"
                :items-per-page="itemsPerPage"
                :mobile-breakpoint="0"
                :page.sync="page"
                single-line
                hide-details
              >
                <template
                  v-if="!$vuetify.breakpoint.smAndDown"
                  v-slot:item="{ item, index }"
                >
                  <tr>
                    <td class="cell">{{ no_run + (index + 1) }}</td>
                    <td class="cell">{{ item.roleName }}</td>
                    <td class="cell">{{ item.remark }}</td>
                    <td class="cell">
                      {{ ChangeFormatDate(item.createTime) }}
                    </td>
                    <td class="cell">
                      {{ ChangeFormatDate(item.updateTime) }}
                    </td>
                    <td
                      style="
                        padding-bottom: 5px;
                        display: flex;
                        flex-direction: column-reverse;
                        align-items: center;
                      "
                    >
                      <v-btn
                        :color="GetColor(item.active)"
                        rounded
                        class="text-capitalize status-pill"
                        depressed
                      >
                        <span :style="{ color: GetColorText(item.active) }">{{
                          item.active == true ? "Active" : "InActive"
                        }}</span>
                      </v-btn>
                    </td>
                    <td style="text-align: center">
                      <v-btn
                        class="mx-1"
                        fab
                        dark
                        small
                        color="#231F20"
                        @click="OpenRoleDetailDialog(item.roleID)"
                      >
                        <v-icon dark> mdi-pencil-outline </v-icon>
                      </v-btn>
                      <template>
                        <v-btn
                          class="mx-1"
                          fab
                          dark
                          small
                          color="red"
                          @click="InActiveRole(item.roleID)"
                        >
                          <v-icon dark>mdi-trash-can-outline </v-icon>
                        </v-btn>
                      </template>
                    </td>
                  </tr>
                </template>
                <template v-else v-slot:item="{ item, index }">
                  <tr>
                    <td class="cell">{{ no_run + (index + 1) }}</td>
                    <td class="cell">{{ item.roleName }}</td>
                    <td
                      style="
                        padding-bottom: 5px;
                        display: flex;
                        flex-direction: column-reverse;
                        align-items: center;
                      "
                    >
                      <v-btn
                        :color="GetColor(item.active)"
                        rounded
                        class="text-capitalize status-pill"
                        depressed
                      >
                        <span :style="{ color: GetColorText(item.active) }">{{
                          item.active == true ? "Active" : "InActive"
                        }}</span>
                      </v-btn>
                    </td>
                    <td style="text-align: center">
                      <v-btn
                        class="mx-1"
                        fab
                        dark
                        small
                        color="#231F20"
                        @click="OpenRoleDetailDialog(item.roleID)"
                      >
                        <v-icon dark> mdi-pencil-outline </v-icon>
                      </v-btn>
                      <template>
                        <v-btn
                          class="mx-1"
                          fab
                          dark
                          small
                          color="red"
                          @click="InActiveRole(item.roleID)"
                        >
                          <v-icon dark>mdi-trash-can-outline </v-icon>
                        </v-btn>
                      </template>
                    </td>
                  </tr>
                </template>
              </v-data-table>
            </div>
              <v-row class="table-footer" align="center" justify="space-between">
                <v-col cols="12" md="3" class="d-none d-md-block"></v-col>
                <v-col cols="12" md="4" class="pagination-column text-center">
                  <v-pagination
                    v-model="page"
                    :total-visible="20"
                    :length="pageCount"
                    @input="ChangePage(page)"
                  ></v-pagination>
                </v-col>
                <v-col cols="12" md="2" class="items-per-page-column">
                  <v-autocomplete
                    dense
                    solo
                    v-model="itemsPerPage"
                    @input="ChangePerPage(itemsPerPage)"
                    :items="items"
                    label="Items/page"
                  ></v-autocomplete>
                </v-col>
              </v-row>
            </v-card>
        </v-card-text>
      </div>
    </v-card>

    <v-dialog v-model="RoleDetailDialog" persistent max-width="900px">
      <v-card class="manage-role-dialog-card">
        <v-card-title class="manage-role-dialog-header">
          <span class="manage-role-dialog-title">{{ $t("message.ManageRole") }}</span>
          <v-btn
            class="dialog-close-btn"
            icon
            @click="CloseRoleDetailDialog()"
          >
            <v-icon color="white" size="30">mdi-close</v-icon>
          </v-btn>
        </v-card-title>
        <v-card-text class="manage-role-dialog-body">
          <v-row class="dialog-form-row">
            <v-col cols="12" md="4" v-if="EditStatus">
              <v-text-field
                type="text"
                :label="$t('message.RoleID')"
                disabled
                v-model="RoleID"
                outlined
                dense
              />
            </v-col>
            <v-col cols="12" :md="EditStatus ? 8 : 4">
              <v-text-field
                type="text"
                :label="$t('message.RoleName')"
                v-model="RoleName"
                outlined
                dense
              />
            </v-col>
          </v-row>
          <v-row class="dialog-form-row">
            <v-col cols="12" md="12">
              <v-text-field
                type="text"
                :label="$t('message.Remark')"
                v-model="Remark"
                outlined
                dense
              />
            </v-col>
          </v-row>
          <span class="permission-title">{{
            $t("message.Permission")
          }}</span>
          <v-row>
            <v-col v-for="item in Permission" :key="item.id" cols="12" md="3">
              <label class="permission-checkbox">
                <input
                  v-model="item.active"
                  class="permission-checkbox__input"
                  type="checkbox"
                />
                <span class="permission-checkbox__box" aria-hidden="true"></span>
                <span class="permission-checkbox__label">
                  {{
                  $te(`message.${item.permissionName}`)
                    ? $t(`message.${item.permissionName}`)
                    : item.permissionName
                  }}
                </span>
              </label>
            </v-col>
          </v-row>

          <v-row class="dialog-status-row">
            <v-col cols="12">
              <v-radio-group row v-model="Active">
                <v-radio color="#231F20" :label="$t('message.Active')" value="1"></v-radio>
                <v-radio color="#231F20" :label="$t('message.InActive')" value="2"></v-radio>
              </v-radio-group>
            </v-col>
          </v-row>
          <v-card-actions class="dialog-actions">
            <v-btn
              v-if="EditStatus"
              color="#231F20"
              class="white--text text-capitalize dialog-primary-btn"
              @click="updateRole()"
              >{{ $t("message.Submit") }}</v-btn
            >
            <v-btn
              v-else
              color="#231F20"
              class="white--text text-capitalize dialog-primary-btn"
              @click="updateRole()"
              >{{ $t("message.Submit") }}</v-btn
            >
            <v-btn
              class="text-capitalize dialog-cancel-btn"
              outlined
              @click="CloseRoleDetailDialog()"
              >{{ $t("message.Cancel") }}</v-btn
            >
          </v-card-actions>
        </v-card-text>
      </v-card>
    </v-dialog>

    <v-dialog v-model="LoadingDialog" persistent width="auto">
      <v-card
        class="pa-6 d-flex flex-column align-center justify-center"
        elevation="8"
        rounded="xl"
      >
        <v-progress-circular
          indeterminate
          color="indigo"
          size="70"
          width="6"
        ></v-progress-circular>
        <span class="mt-4 text-subtitle-1 font-weight-medium"
          >Loading, please wait...</span
        >
      </v-card>
    </v-dialog>
  </div>
</template>
  
  <script>
import axios from "axios";
import enurl from "@/api/environment";
import Swal from "sweetalert2/dist/sweetalert2.js";

export default {
  name: "ManageRole",
  components: {},
  data() {
    return {
      url: enurl.apiUrl,
      LoadingDialog: false,
      items: [10, 15, 20, 50, 100],
      pageCount: 0,
      page: 1,
      itemsPerPage: 10,
      search: "",
      no_run: 0,
      ListData: [],
      RoleDetailDialog: false,
      EditStatus: false,
      RoleID: 0,
      RoleName: "",
      Remark: "",
      RedemptionStatus: false,
      MyQRStatus: false,
      PreRegisterStatus: false,
      CallLiftStatus: false,
      ManageUserStatus: false,
      TerminalStampStatus: false,
      ParkingLotStatus: false,
      Active: null,
      PermissionMenu: [],
      Permission: [],
    };
  },
  computed: {
    headers() {
      return [
        {
          text: this.$t("message.No"),
          sortable: false,
          align: "left",
        },
        {
          text: this.$t("message.RoleName"),
          align: "left",
          sortable: false,
        },
        {
          text: this.$t("message.Remark"),
          align: "left",
          sortable: false,
        },
        {
          text: this.$t("message.CreateTime"),
          align: "left",
          sortable: false,
        },
        {
          text: this.$t("message.UpdateTime"),
          align: "left",
          sortable: false,
        },
        {
          text: this.$t("message.Status"),
          align: "center",
          sortable: false,
        },
        {
          text: this.$t("message.Action"),
          align: "center",
          sortable: false,
        },
      ];
    },
    headersMobile() {
      return [
        {
          text: "No",
          sortable: false,
          align: "left",
        },
        {
          text: "RoleName",
          align: "left",
          sortable: false,
        },
        {
          text: "Status",
          align: "center",
          sortable: false,
        },
        {
          text: "Action",
          align: "center",
          sortable: false,
        },
      ];
    },
  },

  async mounted() {
    let self = this;
    await self.GetRoleList();
  },

  methods: {
    GetRoleList() {
      let self = this;
      self.LoadingDialog = true;
      let temp = {
        search: self.search,
        page: self.page,
        perPage: self.itemsPerPage,
      };
      axios
        .post(`${self.url}Management/getDatRoleList`, temp)
        .then(function (response) {
          if (response.data.status == 0) {
            self.ListData = response.data.data.listData;
            self.pageCount = response.data.data.count;
            self.no_run = (self.page - 1) * self.itemsPerPage;
            self.LoadingDialog = false;
          }
          self.LoadingDialog = false;
        })
        .catch(function (error) {
          self.LoadingDialog = false;
          Swal.fire({
            icon: "error",
            title: "Error...",
            width: 500,
            text: error.response.data.message,
          });
        });
    },

    ChangePage(value) {
      let self = this;
      self.LoadingDialog = true;
      let temp = {
        page: value,
        perPage: self.itemsPerPage,
        search: self.search == null ? "" : self.search,
      };
      axios
        .post(`${self.url}Management/getDatRoleList`, temp)
        .then(function (response) {
          if (response.data.status == 0) {
            self.ListData = response.data.data.listData;
            self.pageCount = response.data.data.count;
            self.no_run = (self.page - 1) * self.itemsPerPage;
            self.LoadingDialog = false;
          }
          self.LoadingDialog = false;
        })
        .catch(function (error) {
          self.LoadingDialog = false;
          Swal.fire({
            icon: "error",
            title: "Error...",
            width: 500,
            text: error.response.data.message,
          });
        });
    },

    ChangePerPage(value) {
      let self = this;
      self.LoadingDialog = true;
      let temp = {
        search: self.search,
        page: 1,
        perPage: value,
      };
      axios
        .post(`${self.url}Management/getDatRoleList`, temp)
        .then(function (response) {
          if (response.data.status == 0) {
            self.ListData = response.data.data.listData;
            self.pageCount = response.data.data.count;
            self.no_run = (self.page - 1) * self.itemsPerPage;
            self.LoadingDialog = false;
          }
          self.LoadingDialog = false;
        })
        .catch(function (error) {
          self.LoadingDialog = false;
          Swal.fire({
            icon: "error",
            title: "Error...",
            width: 500,
            text: error.response.data.message,
          });
        });
    },

    SearchDataRoleList(value) {
      let self = this;
      self.LoadingDialog = true;
      let temp = {
        search: value,
        page: 1,
        perPage: self.itemsPerPage,
      };
      axios
        .post(`${self.url}Management/getDatRoleList`, temp)
        .then(function (response) {
          if (response.data.status == 0) {
            self.ListData = response.data.data.listData;
            self.pageCount = response.data.data.count;
            self.no_run = (self.page - 1) * self.itemsPerPage;
            self.LoadingDialog = false;
          }
          self.LoadingDialog = false;
        })
        .catch(function (error) {
          self.LoadingDialog = false;
          Swal.fire({
            icon: "error",
            title: "Error...",
            width: 500,
            text: error.response.data.message,
          });
        });
    },

    CloseRoleDetailDialog() {
      let self = this;
      self.EditStatus = false;
      self.RoleID = 0;
      self.RoleName = "";
      self.Remark = "";
      self.RedemptionStatus = false;
      self.MyQRStatus = false;
      self.PreRegisterStatus = false;
      self.CallLiftStatus = false;
      self.ManageUserStatus = false;
      self.TerminalStampStatus = false;
      self.Active = null;
      self.RoleDetailDialog = false;
    },

    OpenRoleDetailDialog(id) {
      let self = this;
      if (id != 0) {
        self.LoadingDialog = true;
        let temp = {
          roleID: id,
        };
        axios
          .post(`${self.url}Management/getDatRoleByRoleID`, temp)
          .then(function (response) {
            if (response.data.status == 0) {
              self.BindingDataRole(response.data.data);
              self.LoadingDialog = false;
            }
            self.LoadingDialog = false;
          })
          .catch(function (error) {
            self.LoadingDialog = false;
            Swal.fire({
              icon: "error",
              title: "Error...",
              width: 500,
              text: error.response.data.message,
            });
          });
      }
    },

    OpenAddRoleDetailDialog() {
      let self = this;
      self.EditStatus = false;
      self.RoleID = 0;
      self.RoleName = "";
      self.Remark = "";
      self.RedemptionStatus = false;
      self.MyQRStatus = false;
      self.PreRegisterStatus = false;
      self.CallLiftStatus = false;
      self.ManageUserStatus = false;
      self.Active = "1";

      const keyMap = {
        Redemption: "redemption",
        // MyQR: "qr",
        // PreRegister: "preRegister",
        // CallLift: "callLift",
        ManageUser: "manageUser",
        TerminalStamp: "terminalStamp",
        ParkingLot: "parkingLot",
      };

      self.Permission = Object.keys(keyMap).map((key, index) => ({
        id: index + 1,
        permissionName: key,
        active: false,
      }));
      self.RoleDetailDialog = true;
    },

    BindingDataRole(data) {
      let self = this;
      self.EditStatus = true;
      self.RoleID = data.roleID;
      self.RoleName = data.roleName;
      self.Remark = data.remark;
      const permission = data.permission || {};
      const permissionMenu = data.permissionMenu || [];

      const keyMap = {
        Redemption: "redemption",
        MyQR: "qr",
        PreRegister: "preRegister",
        CallLift: "callLift",
        ManageUser: "manageUser",
        TerminalStamp: "terminalStamp",
        ParkingLot: "parkingLot",
      };

      self.Permission = permissionMenu.map((menu) => ({
        id: menu.id,
        permissionName: menu.permissionName,
        active: !!permission[keyMap[menu.permissionName]],
      }));

      self.Active = data.active === true ? "1" : "2";
      self.RoleDetailDialog = true;
    },

    async updateRole() {
      let self = this;
      self.LoadingDialog = true;
      try {
        const keyMap = {
          Redemption: "redemption",
          MyQR: "qr",
          PreRegister: "preRegister",
          CallLift: "callLift",
          ManageUser: "manageUser",
          TerminalStamp: "terminalStamp",
          ParkingLot: "parkingLot",
        };

        const permissionPayload = {
          redemption: false,
          qr: false,
          preRegister: false,
          callLift: false,
          manageUser: false,
          terminalStamp: false,
          parkingLot: false,
        };

        (self.Permission || []).forEach((p) => {
          const permissionName = String(p.permissionName || "").trim();
          const key = keyMap[permissionName];
          if (key) {
            permissionPayload[key] = !!p.active;
          }
        });
        const payload = {
          roleName: self.RoleName,
          remark: self.Remark,
          permission: permissionPayload,
          active:
            self.Active === "1" ? true : self.Active === "2" ? false : null,
        };
        if (self.EditStatus) {
          payload.roleID = self.RoleID;
        }
        const url = self.EditStatus
          ? `${self.url}Management/updateRole`
          : `${self.url}Management/addRole`;
        const res = await axios.post(url, payload);
        if (res?.data?.status === 0) {
          Swal.fire({
            icon: "success",
            title: "Success",
            showConfirmButton: false,
            timer: 1500,
          });
          self.CloseRoleDetailDialog();
          if (!self.EditStatus) {
            self.page = 1;
          }
          self.GetRoleList();
        } else {
          throw new Error(res?.data?.message || "Save failed");
        }
      } catch (error) {
        Swal.fire({
          icon: "error",
          width: 500,
          text: error?.response?.data?.message || error.message || "Error",
        });
      } finally {
        self.LoadingDialog = false;
      }
    },

    InActiveRole(id) {
      let self = this;
      if (id != 0) {
        let temp = {
          roleID: id,
        };
        axios
          .post(`${self.url}Management/inActiveRoleByRoleID`, temp)
          .then(function (response) {
            if (response.data.status == 0) {
              Swal.fire({
                icon: "success",
                title: "Success",
                showConfirmButton: false,
                timer: 1500,
              });
              self.GetRoleList();
            }
            self.LoadingDialog = false;
          })
          .catch(function (error) {
            self.LoadingDialog = false;
            Swal.fire({
              icon: "error",
              title: "Error...",
              width: 500,
              text: error.response.data.message,
            });
          });
      }
    },

    GetColor(value) {
      if (value == true) {
        return "#88C982";
      } else {
        return "#EF8585";
      }
    },

    GetColorText(value) {
      if (value == true) {
        return "#514D4E";
      } else {
        return "#514D4E";
      }
    },

    ChangeFormatDate(date) {
      if (!date) return null;
      var DateData = new Date(date);
      var hours = DateData.getHours();
      var minutes = DateData.getMinutes();
      minutes = minutes < 10 ? "0" + minutes : minutes;
      var strTime = hours + ":" + minutes;
      return (
        DateData.getDate() +
        "/" +
        (DateData.getMonth() + 1) +
        "/" +
        DateData.getFullYear() +
        "  " +
        strTime
      );
    },
  },
};
</script>
<style scoped>
@font-face {
  font-family: "Mrs Eaves Lining OT";
  src: url("~@/assets/Font/Lining.otf") format("opentype");
  font-display: swap;
}

* >>> .v-data-table-header {
  background-color: #231f20;
  color: #fff !important;
}

* >>> .v-data-table-header th {
  color: #fff !important;
  font-family: "Mrs Eaves Lining OT", "Times New Roman", serif !important;
  font-size: 16px !important;
  font-weight: 400 !important;
  height: 58px !important;
  letter-spacing: 0.025em;
}

.manage-role-page {
  min-height: calc(100vh - 120px);
  padding: 0 3.75vw 56px;
}

.manage-role-content {
  padding: 0 !important;
}

.page-title {
  color: #231f20;
  font-family: "Mrs Eaves Lining OT", "Times New Roman", serif !important;
  font-size: 32px;
  font-weight: 400;
  letter-spacing: 0.02em;
  line-height: 1.25;
  padding-top: 42px;
  text-align: center;
}

.search-section {
  align-items: center;
  display: flex;
  gap: 16px;
  margin: 72px auto 68px;
  max-width: 940px;
}

.search-control {
  flex: 1;
}

.create-control {
  flex: 0 0 auto;
}

.search-field >>> .v-input__slot {
  background: #fff;
  border-radius: 30px !important;
  min-height: 58px;
}

.search-field >>> fieldset {
  border-color: #3f3b3c !important;
}

.search-field >>> input {
  color: #514d4e !important;
  font-family: "Mrs Eaves Lining OT", "Times New Roman", serif !important;
  font-size: 17px;
  padding-left: 18px;
}

.search-field >>> .v-input__append-inner {
  margin-top: 15px;
}

.search-normal-icon {
  display: block;
  height: 24px;
  width: 24px;
}

.create-role-btn {
  border-radius: 28px;
  font-family: "Mrs Eaves Lining OT", "Times New Roman", serif !important;
  font-size: 17px;
  height: 52px !important;
  min-width: 120px !important;
  text-transform: none;
}

.table-card {
  border-radius: 12px !important;
  box-shadow: 0 8px 14px rgba(35, 31, 32, 0.16) !important;
  overflow: hidden;
}

.table-scroll {
  overflow-x: auto;
}

.data-table {
  color: #514d4e;
  font-family: "Mrs Eaves Lining OT", "Times New Roman", serif !important;
  min-width: 900px;
}

.data-table >>> tbody tr:nth-child(odd) {
  background: #faf9f8;
}

.data-table >>> tbody tr:hover {
  background: #f1efee !important;
}

.data-table >>> tbody td {
  border-bottom: 0 !important;
  height: 68px;
}

.data-table >>> tbody td.cell {
  color: #514d4e;
  font-family: "Mrs Eaves Lining OT", "Times New Roman", serif !important;
  font-size: 18px !important;
  padding: 14px 16px;
  white-space: nowrap;
}

.data-table >>> .status-pill,
.data-table >>> .status-pill * {
  font-family: "Mrs Eaves Lining OT", "Times New Roman", serif !important;
  font-size: 18px !important;
}

.status-pill {
  height: 36px !important;
  min-width: 98px !important;
}

.data-table >>> .v-btn--fab.v-size--small {
  height: 36px;
  width: 36px;
}

.data-table >>> .v-btn--fab.v-size--small .v-icon {
  font-size: 20px;
}

.table-footer {
  margin: 0 !important;
  min-height: 110px;
  padding: 14px 20px 8px;
  position: relative;
}

.items-per-page-column {
  flex: 0 0 93px;
  max-width: 93px;
  padding: 0 !important;
}

.items-per-page-column >>> .v-input__slot,
.items-per-page-column >>> .v-input__control {
  height: 35px;
  min-height: 35px;
}

.items-per-page-column >>> .v-input__slot {
  border-radius: 24px !important;
}

.items-per-page-column >>> .v-text-field__details {
  display: none;
}

.items-per-page-column >>> .v-select__selection,
.items-per-page-column >>> .v-label,
.pagination-column >>> .v-pagination__item {
  font-family: "Mrs Eaves Lining OT", "Times New Roman", serif !important;
}

.pagination-column >>> .v-pagination__item,
.pagination-column >>> .v-pagination__navigation {
  border-radius: 9px;
  box-sizing: border-box;
  height: 46px;
  min-width: 46px;
}

.pagination-column >>> .v-pagination__item {
  border: 2px solid transparent;
}

.pagination-column >>> .v-pagination__navigation,
.pagination-column >>> .v-pagination__navigation--disabled {
  background: #231f20 !important;
  color: #fff;
  opacity: 1 !important;
}

.pagination-column >>> .v-pagination__navigation .v-icon {
  color: #fff;
}

.pagination-column >>> .v-pagination__item--active {
  background: #fff !important;
  border-color: #231f20 !important;
  color: #231f20 !important;
}

.manage-role-dialog-card {
  border-radius: 14px !important;
  height: 640px;
  overflow: hidden;
}

.manage-role-dialog-header {
  align-items: center;
  background: #231f20;
  color: #fff;
  display: flex;
  height: 58px;
  justify-content: center;
  padding: 0 50px !important;
  position: relative;
}

.manage-role-dialog-title,
.permission-title,
.manage-role-dialog-body >>> .v-label,
.manage-role-dialog-body >>> input,
.manage-role-dialog-body >>> .v-input,
.manage-role-dialog-body >>> .v-btn {
  font-family: "Mrs Eaves Lining OT", "Times New Roman", serif !important;
  font-size: 18px;
}

.manage-role-dialog-title {
  font-size: 24px;
  letter-spacing: 0.02em;
  line-height: 1;
}

.dialog-close-btn {
  position: absolute;
  right: 12px;
  top: 9px;
}

.dialog-close-btn >>> .v-icon {
  font-size: 32px !important;
}

.manage-role-dialog-body {
  color: #231f20 !important;
  display: flex;
  flex-direction: column;
  height: calc(100% - 58px);
  overflow-y: auto;
  padding: 26px 36px 28px !important;
}

.dialog-form-row {
  margin: 0 -6px !important;
}

.dialog-form-row > .col {
  padding: 0 6px 14px !important;
}

.manage-role-dialog-body >>> .v-text-field {
  max-width: 100%;
}

.manage-role-dialog-body >>> .v-text-field__details {
  display: none;
}

.manage-role-dialog-body >>> .v-text-field--outlined > .v-input__control > .v-input__slot {
  border-radius: 18px !important;
  height: 58px;
  min-height: 58px;
}

.manage-role-dialog-body >>> .v-text-field--outlined fieldset {
  border-color: #403c3d;
}

.manage-role-dialog-body >>> .v-text-field--outlined .v-label--active {
  top: 6px;
  transform: translateY(0) scale(0.75) !important;
  transform-origin: top left;
}

.manage-role-dialog-body >>> .v-text-field--outlined legend {
  width: 0 !important;
}

.manage-role-dialog-body >>> .v-text-field--outlined input {
  padding: 18px 14px 6px;
}

.permission-title {
  color: #231f20;
  display: block;
  font-size: 24px;
  margin: 18px 0 12px;
}

.manage-role-dialog-body > .row:not(.dialog-form-row):not(.dialog-status-row) {
  margin: 0 -6px !important;
}

.manage-role-dialog-body > .row:not(.dialog-form-row):not(.dialog-status-row) > .col {
  padding: 8px 14px !important;
}

.manage-role-dialog-body >>> .v-radio .v-label {
  color: #514d4e;
  font-family: "Mrs Eaves Lining OT", "Times New Roman", serif !important;
  font-size: 18px;
}

.manage-role-dialog-body >>> .v-radio .v-icon {
  font-size: 26px;
}

.permission-checkbox {
  display: inline-flex;
  align-items: center;
  min-height: 44px;
  color: #231f20;
  cursor: pointer;
}

.permission-checkbox__input {
  position: absolute;
  width: 1px;
  height: 1px;
  overflow: hidden;
  clip: rect(0 0 0 0);
  clip-path: inset(50%);
  white-space: nowrap;
}

.permission-checkbox__box {
  position: relative;
  flex: 0 0 24px;
  width: 24px;
  height: 24px;
  background: #ffffff;
  border: 2px solid #231f20;
  border-radius: 3px;
}

.permission-checkbox__box::after {
  content: "";
  position: absolute;
  top: 4px;
  left: 4px;
  width: 12px;
  height: 7px;
  border-bottom: 2px solid #231f20;
  border-left: 2px solid #231f20;
  opacity: 0;
  transform: rotate(-45deg);
}

.permission-checkbox__input:checked + .permission-checkbox__box::after {
  opacity: 1;
}

.permission-checkbox__input:focus-visible + .permission-checkbox__box {
  outline: 3px solid #767071;
  outline-offset: 3px;
}

.permission-checkbox__label {
  margin-left: 10px;
  font-family: "Mrs Eaves Lining OT", "Times New Roman", serif;
  font-size: 18px;
  line-height: 1.3;
}

.dialog-status-row {
  margin: 24px 0 0 !important;
}

.dialog-status-row >>> .v-input--radio-group {
  margin-top: 0;
  padding-top: 0;
}

.dialog-status-row >>> .v-radio {
  margin-right: 34px;
}

.dialog-actions {
  gap: 20px;
  justify-content: center;
  margin-top: auto;
  padding: 18px 0 4px !important;
}

.dialog-primary-btn,
.dialog-cancel-btn {
  border-radius: 30px;
  box-shadow: 0 7px 10px rgba(35, 31, 32, 0.24) !important;
  font-size: 18px !important;
  height: 52px !important;
  margin: 0 !important;
  min-width: 168px !important;
  text-transform: none;
}

.dialog-cancel-btn {
  background: #fff !important;
  border-color: #231f20 !important;
  color: #231f20 !important;
}

@media (min-width: 960px) {
  .pagination-column {
    left: 50%;
    position: absolute;
    transform: translateX(-50%);
  }

  .items-per-page-column {
    margin-left: auto;
  }
}

@media (max-width: 959px) {
  .manage-role-page {
    padding: 0 16px 36px;
  }

  .page-title {
    font-size: 26px;
    padding-top: 28px;
  }

  .search-section {
    align-items: stretch;
    flex-direction: column;
    margin: 36px auto 34px;
  }

  .create-role-btn {
    width: 100%;
  }

  .table-footer {
    padding: 10px 8px 14px;
  }

  .items-per-page-column {
    margin: 0 auto;
    max-width: 93px;
  }

  .manage-role-dialog-card {
    height: calc(100vh - 32px);
  }

  .manage-role-dialog-header {
    height: 56px;
  }

  .manage-role-dialog-title {
    font-size: 24px;
  }

  .dialog-close-btn {
    right: 8px;
    top: 4px;
  }

  .dialog-close-btn >>> .v-icon {
    font-size: 32px !important;
  }

  .manage-role-dialog-body {
    height: calc(100% - 56px);
    padding: 22px 18px 32px !important;
  }

  .manage-role-dialog-body >>> .v-text-field--outlined > .v-input__control > .v-input__slot {
    height: 58px;
    min-height: 58px;
  }

  .permission-title {
    font-size: 24px;
    margin-top: 10px;
  }

  .dialog-status-row {
    margin-top: 28px !important;
  }

  .dialog-actions {
    gap: 12px;
    flex-wrap: wrap;
  }

  .dialog-primary-btn,
  .dialog-cancel-btn {
    flex: 1 1 140px;
    min-width: 140px !important;
  }
}

@media (prefers-reduced-motion: reduce) {
  *,
  *::before,
  *::after {
    animation-duration: 0.01ms !important;
    animation-iteration-count: 1 !important;
    transition-duration: 0.01ms !important;
  }
}
</style>
